"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStoryContentProperty = exports.storyContentPropertyDefinition = void 0;
exports.storyContentPropertyDefinition = {
    view: { label: 'Story content' },
    constraints: [
        {
            name: 'properties',
            argument: [
                'text',
                'headline',
                'quote',
                'list',
                'numbered-list',
                'table',
                'service-embed',
                'image',
                'image-gallery',
                'video',
                'audio',
                'tip',
                'fact',
                'couple',
                'interview',
                'accordion',
                'embedded-content',
                'legal-disclaimer',
                'info-block-group',
            ],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'story-content',
};
const isStoryContentProperty = (prop) => {
    return prop.name === exports.storyContentPropertyDefinition.name;
};
exports.isStoryContentProperty = isStoryContentProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcnktY29udGVudC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3N0b3J5LWNvbnRlbnQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBdUJhLFFBQUEsOEJBQThCLEdBQUc7SUFDNUMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGVBQWUsRUFBRTtJQUNoQyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxZQUFZO1lBQ2xCLFFBQVEsRUFBRTtnQkFDUixNQUFNO2dCQUNOLFVBQVU7Z0JBQ1YsT0FBTztnQkFDUCxNQUFNO2dCQUNOLGVBQWU7Z0JBQ2YsT0FBTztnQkFDUCxlQUFlO2dCQUNmLE9BQU87Z0JBQ1AsZUFBZTtnQkFDZixPQUFPO2dCQUNQLE9BQU87Z0JBQ1AsS0FBSztnQkFDTCxNQUFNO2dCQUNOLFFBQVE7Z0JBQ1IsV0FBVztnQkFDWCxXQUFXO2dCQUNYLGtCQUFrQjtnQkFDbEIsa0JBQWtCO2dCQUNsQixrQkFBa0I7YUFDbkI7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsZUFBZTtDQUNVLENBQUE7QUE0QjFCLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxJQUFrQixFQUFnQyxFQUFFO0lBQ3pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLENBQUE7QUFDMUQsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=